module.exports = __webpack_public_path__ + "static/media/Carracosta_gaussian2.8226e710.png";